import { Accordion as ArkAccordion } from "@ark-ui/react";
import React, { useState } from "react";
import { tv } from "tailwind-variants";

// Define styles using tailwind-variants
const accordionStyles = tv({
  base: "h-full w-3/4 rounded-lg bg-brand-slate ",
  variants: {},
});

const triggerStyles = tv({
  base: "w-full cursor-pointer",
  variants: {},
});

const contentStyles = tv({
  base: "h-auto rounded-lg bg-brand-slate",
  variants: {},
});

const itemContentStyles = tv({
  base: "ml-16 flex h-auto items-center",
  variants: {},
});

interface AccordionProps {
  trigger: React.ReactNode;
  children: React.ReactNode[];
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
  itemContentClassName?: string;
}

export const Accordion = ({
  trigger,
  children,
  className,
  triggerClassName,
  contentClassName,
  itemContentClassName,
}: AccordionProps): React.JSX.Element => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <ArkAccordion.Root collapsible className={accordionStyles({ className })}>
      <ArkAccordion.Item value="" className="">
        <ArkAccordion.ItemTrigger
          className={triggerStyles({ className: triggerClassName })}
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        >
          <div className="flex">
            <div className="mr-6 ml-2 flex h-auto items-center justify-center">
              {isAccordionOpen ? (
                <span className="icon-[ic--baseline-minus] h-8 w-8" />
              ) : (
                <span className="icon-[ic--baseline-plus] h-8 w-8" />
              )}
            </div>
            {trigger}
          </div>

          {isAccordionOpen ? <div className="absolute mt-0 h-[1px] w-3/4 bg-white-600" /> : ""}
        </ArkAccordion.ItemTrigger>
        {children.map((item, index) => (
          <ArkAccordion.ItemContent
            key={index}
            className={contentStyles({ className: contentClassName })}
          >
            <div className={itemContentStyles({ className: itemContentClassName })}>{item}</div>
          </ArkAccordion.ItemContent>
        ))}
      </ArkAccordion.Item>
    </ArkAccordion.Root>
  );
};
